import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

import LinkCTA from '../LinkCTA'
import { CardWrapper, ContentBox, ImageBox } from './styles'

interface DownloadCardProps {
  body: string
  featureImage: any
  linkText?: string
  linkTarget?: string
  shortDescription?: string
}

const DownloadCard = (props: DownloadCardProps) => {
  const {
    body,
    featureImage,
    linkText = 'Download',
    linkTarget = '/',
    shortDescription = '',
  } = props
  const thumbnailImage = getImage(featureImage?.imgixImage)
  const altText = featureImage?.description || ''

  return (
    <CardWrapper>
      <ImageBox>
        {thumbnailImage ? (
          <GatsbyImage alt={altText} image={thumbnailImage} />
        ) : null}
      </ImageBox>
      <ContentBox>
        <p className="cardBody">{body}</p>
        <p className="cardShort">{shortDescription}</p>
        <LinkCTA arrow directUrl={linkTarget} variant="primary">
          {linkText}
        </LinkCTA>
      </ContentBox>
    </CardWrapper>
  )
}

export default DownloadCard
